import PropTypes from 'prop-types'
import { FitnessTrackerContext } from '../Context/FitnessTrackerContext'
import { useFitnessTracker } from '../Hooks/useFitnessTracker'
import { canUseFitnessTracker } from '../Utils/utils'

export default function FitnessTrackerProvider({ children }) {
  const userId = localStorage.getItem('user_id')
  const tracker = useFitnessTracker({
    userId,
    enabled: canUseFitnessTracker(userId),
  })

  return (
    <FitnessTrackerContext.Provider value={tracker}>
      {children}
    </FitnessTrackerContext.Provider>
  )
}

FitnessTrackerProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
